import { api } from '@/api'

export function deassignOrderTypeFromServiceAction(serviceSlug: string, orderTypePurchaseCuid: string) {
  return api.v2.delete(`/services/${serviceSlug}/order-types/${orderTypePurchaseCuid}`)
}
